import EmObject from '@ember/object';
import { MainConditionInterface } from './abstract';

class InvalidCondition extends EmObject implements MainConditionInterface {
  type = 'invalid';

  trackedAttributes = [];
  changedAttributes = [];

  json: Record<string, unknown> | null = null;

  isDirty = false;
  hasErrors = false;

  get errors() {
    return {};
  }

  validate() {
    return false;
  }

  toString() {
    return 'InvalidCondition';
  }
}

export default InvalidCondition;
